// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".email-title[data-v-3c11229f] {\n  margin: 10px 0;\n}\n.email-box[data-v-3c11229f] {\n  width: 58%;\n  margin-left: 8.3%;\n}\n.emails-container[data-v-3c11229f] {\n  width: 100%;\n  height: 80px;\n  overflow-y: auto;\n  padding: 5px;\n  border: 1px solid #d9d9d9;\n}\n.send-btn[data-v-3c11229f] {\n  width: 100%;\n  margin: 10px;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
